import { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import balanceIcon from "../../../assets/img/available-funds.svg";

import mealBenefitImageV2 from "../../../assets/img/v2/meal-benefit.png";
import transportBenefitImageV2 from "../../../assets/img/v2/transport-benefit.png";
import nurseryBenefitImageV2 from "../../../assets/img/v2/nursery-benefit.png";

import "./parameters-section.scss";
import { displaySubsidyEmployees } from "../displays/allowance/display-subsidy-employees";
import SubsidyBenefitCard from "../../../app/components/subsidy/SubsidyBenefitCard";
import SubsidyBenefitAmountCard from "../../../app/components/subsidy/SubsidyBenefitAmountCard";
import { translate as t } from "../../../infrastructure/translate/localization";
import {
  changeGeneralParameters,
  handlerAllowanceFormatted,
} from "../../../infrastructure/allowance-config-repository";

export default class ParametersSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mealDays: 0,
      mealAmount: "",
      transportAmount: "",
      nurseryAmount: "",
      meal: false,
      transport: false,
      nursery: false,
    };
  }

  componentDidMount() {
    const {
      mealDays,
      mealAmount,
      mealBenefit,
      transportAmount,
      transportBenefit,
      nurseryAmount,
      nurseryBenefit,
    } = this.props;
    this.setState({
      mealDays,
      mealAmount,
      transportAmount,
      nurseryAmount,
      meal: mealBenefit,
      transport: transportBenefit,
      nursery: nurseryBenefit,
    });
  }

  toggleBenefit = ({ name, value }) => {
    changeGeneralParameters({ parameter: `${name}Amount`, value });
    // eslint-disable-next-line react/destructuring-assignment
    const nameId = this.state[name];

    this.setState(
      {
        [name]: !nameId,
        [`${name}Amount`]: Math.abs(value),
      },
      this.handlerSubsidyEmployee
    );
  };

  handlerSubsidyEmployee = () => {
    const { model, recurrentSubsidy } = this.props;
    const { meal, transport, nursery } = this.state;
    displaySubsidyEmployees({
      model,
      mealBenefit: meal,
      transportBenefit: transport,
      nurseryBenefit: nursery,
      recurrentSubsidy,
    });
  };

  editAllowanceParameter = (type, amount) => {
    if (type === "mealDays") {
      changeGeneralParameters({ parameter: type, value: amount });
      return this.setState({ [type]: amount });
    }
    const { countryISO2Code } = this.props;
    const value = handlerAllowanceFormatted(type, amount, countryISO2Code);
    changeGeneralParameters({ parameter: type, value });
    return this.setState({ [type]: value });
  };

  render() {
    const {
      balance,
      mealBenefit,
      transportBenefit,
      nurseryBenefit,
      recurrentSubsidy,
    } = this.props;
    const {
      meal,
      transport,
      nursery,
      mealDays,
      mealAmount,
      transportAmount,
      nurseryAmount,
    } = this.state;

    const options = [];
    for (let i = 1; i <= 27; i += 1) {
      options.push(i);
    }

    return (
      <>
        <div className="parameters-section">
          <div className="balance-content">
            {!recurrentSubsidy && (
              <div className="balance-info">
                <div className="balance-thumbnail">
                  <img src={balanceIcon} alt="Balance" />
                </div>
                <div className="balance-available">
                  <span>{t("my-account-section.balance")}</span>
                  <span className="amount">{balance}</span>
                </div>
              </div>
            )}

            <div className="benefits-cards">
              {!recurrentSubsidy && (
                <p className="benefits-cards-description">
                  {t("subsidy-section.select-benefit")}
                </p>
              )}

              <div className="benefits-cards-content">
                <SubsidyBenefitCard
                  title={t("benefits-section.meal-benefit.meal")}
                  image={mealBenefitImageV2}
                  active={meal}
                  disabled={!mealBenefit}
                  handlerClick={() =>
                    this.toggleBenefit({ name: "meal", value: 0 })
                  }
                />
                <SubsidyBenefitCard
                  title={t("benefits-section.transport-benefit.transport")}
                  image={transportBenefitImageV2}
                  active={transport}
                  disabled={!transportBenefit}
                  handlerClick={() =>
                    this.toggleBenefit({
                      name: "transport",
                      value: 0,
                    })
                  }
                />
                <SubsidyBenefitCard
                  title={t("benefits-section.nursery-benefit.nursery")}
                  image={nurseryBenefitImageV2}
                  active={nursery}
                  disabled={!nurseryBenefit}
                  handlerClick={() =>
                    this.toggleBenefit({
                      name: "nursery",
                      value: 0,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="parameters-section">
          <div className="balance-content">
            <SubsidyBenefitAmountCard
              hidden={!meal}
              title={t("subsidy-section.benefit-subsidy-by-employee", {
                benefit: t("benefits-section.meal-benefit.meal"),
              })}
            >
              <div className="cob-input-group">
                <label className="input-label">
                  {t("common-messages.days-a-month")}
                </label>
                <div className="cob-select">
                  <select
                    className="cob-select select-day"
                    onChange={(e) => {
                      this.editAllowanceParameter(
                        "mealDays",
                        Math.abs(e.target.value)
                      );
                      this.handlerSubsidyEmployee();
                    }}
                    value={mealDays}
                  >
                    <option disabled>
                      {t("subsidy-section.working-days")}
                    </option>
                    {options.map((m) => (
                      <option defaultValue={m === 20} key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                  <FontAwesomeIcon icon="chevron-down" />
                </div>
              </div>

              <div className="cob-input-group">
                <label className="input-label">
                  {t("common-messages.amount")}
                </label>
                <input
                  placeholder={t("common-messages.amount")}
                  type="number"
                  onFocus={(event) => event.target.select()}
                  onBlur={() => {
                    this.editAllowanceParameter("mealAmount", mealAmount);
                    this.handlerSubsidyEmployee();
                  }}
                  value={mealAmount}
                  onChange={(e) =>
                    this.setState({ mealAmount: e.target.value })
                  }
                />
              </div>
            </SubsidyBenefitAmountCard>

            <SubsidyBenefitAmountCard
              hidden={!transport}
              title={t("subsidy-section.benefit-subsidy-by-employee", {
                benefit: t("benefits-section.transport-benefit.transport"),
              })}
            >
              <div className="cob-input-group">
                <label className="input-label">
                  {t("common-messages.amount")}
                </label>
                <input
                  placeholder={t("common-messages.amount")}
                  type="number"
                  onFocus={(event) => event.target.select()}
                  onBlur={() => {
                    this.editAllowanceParameter(
                      "transportAmount",
                      transportAmount
                    );
                    this.handlerSubsidyEmployee();
                  }}
                  value={transportAmount}
                  onChange={(e) =>
                    this.setState({ transportAmount: e.target.value })
                  }
                />
              </div>
            </SubsidyBenefitAmountCard>

            <SubsidyBenefitAmountCard
              title={t("subsidy-section.benefit-subsidy-by-employee", {
                benefit: t("benefits-section.nursery-benefit.nursery"),
              })}
              hidden={!nursery}
            >
              <div className="cob-input-group">
                <label className="input-label">
                  {t("common-messages.amount")}
                </label>
                <input
                  placeholder={t("common-messages.amount")}
                  type="number"
                  onFocus={(event) => event.target.select()}
                  onBlur={() => {
                    this.editAllowanceParameter("nurseryAmount", nurseryAmount);
                    this.handlerSubsidyEmployee();
                  }}
                  value={nurseryAmount}
                  onChange={(e) =>
                    this.setState({ nurseryAmount: e.target.value })
                  }
                />
              </div>
            </SubsidyBenefitAmountCard>
          </div>
        </div>
      </>
    );
  }
}

ParametersSection.defaultProps = {
  mealDays: 0,
  mealAmount: "",
  mealBenefit: false,
  transportAmount: "",
  transportBenefit: false,
  nurseryAmount: "",
  nurseryBenefit: false,
  recurrentSubsidy: false,
};

ParametersSection.propTypes = {
  mealDays: PropTypes.number,
  mealAmount: PropTypes.string,
  mealBenefit: PropTypes.bool,
  transportAmount: PropTypes.string,
  transportBenefit: PropTypes.bool,
  nurseryAmount: PropTypes.string,
  nurseryBenefit: PropTypes.bool,
  recurrentSubsidy: PropTypes.bool,
  model: PropTypes.object.isRequired,
  balance: PropTypes.string.isRequired,
  countryISO2Code: PropTypes.string.isRequired,
};
